import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    mixins: [emTableCheckedMixin],
    computed: {
        $_emRouterHelperMixin_pathType() {
            return this.isClaim ? 'claim' : this.$route.query.pathType;
        },
        pathType() {
            let tempType = this.$route.query.pathType;
            return tempType ? tempType : 'todo';
        },
        isTypeTodo() {
            return this.pathType === 'todo';
        },
        batchRouterName() {
            return this.modelName + 'TaskBatch';
        },
    },
    data() {
        return {
            isClaim: false,
            claimLoading: false,
        }
    },
    mounted() {
        if (this.$route.query.toClaim) {
            this.isClaim = true;
        }
        if (this.$route.query.hasOwnProperty('processId')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.processId);
            this.$refs.emListFilter.doQuery();
        }
    },
    methods: {
        switchClaim() {
            this.isClaim = !this.isClaim;
        },
        handleExecute(row) {
            if (this.isClaim) {
                if (row.workflowTask && row.workflowTask.processDefinitionKey) {
                    this.claimLoading = true;
                    this.$store.dispatch('api/post', {
                        url: process.env.VUE_APP_EM_WORKFLOW_URL + "/claimTask",
                        data: {
                            processDefinitionKey: row.workflowTask.processDefinitionKey,
                            businessKeyList: [row.id]
                        }
                    }).then(() => {
                        this.$message.success("认领成功");
                        this.$refs['emListFilter'].doQuery();
                    }).finally(() => this.claimLoading = false);
                }
            } else {
                this.$_emWorkflowListMixin_handleApprove(row);
            }
        },
        handleExecuteByTaskId(row) {
            if (this.isClaim) {
                if (row.workflowTask && row.workflowTask.taskInstanceId) {
                    this.claimLoading = true;
                    this.claimTasks([row.workflowTask.taskInstanceId]);
                }
            } else {
                this.$_emWorkflowListMixin_handleApprove(row);
            }
        },
        claimTasks(taskIds) {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_EM_WORKFLOW_URL + "/claimTask",
                data: {
                    taskIdList: taskIds
                }
            }).then(() => {
                this.$message.success("认领成功");
                this.$refs['emListFilter'].doQuery();
            }).finally(() => this.claimLoading = false);
        },
        doClaimBatch() {
            this.claimLoading = true;
            let taskIds = [];
            for (let row of this.checkedRows) {
                if (row.workflowTask && row.workflowTask.taskInstanceId) {
                    taskIds.push(row.workflowTask.taskInstanceId);
                }
            }
            if (taskIds.length > 0) {
                this.claimTasks(taskIds);
            } else {
                this.claimLoading = false;
                this.$message.error("没有可认领的任务")
            }
        },
        handleExecuteBatch() {
            if (this.$_checked) {
                if (this.isClaim) {
                    this.doClaimBatch();
                } else {
                    let taskStatus = null;
                    for (let row of this.checkedRows) {
                        if (taskStatus == null) {
                            taskStatus = row.status;
                        } else if (row.status !== taskStatus) {
                            this.$message.error("必须选择相同状态的待办任务");
                            return;
                        }
                    }
                    this.$router.push({
                        name: this.batchRouterName,
                        params: {
                            rows: this.checkedRows
                        }
                    });
                }
            }
        },
    }
}
